// temp helper until https://github.com/tc39/proposal-array-grouping is widely available

export function groupToMap<TKey, TEntity>(arr: TEntity[], keyFunc: (i: TEntity) => TKey): Map<TKey, TEntity[]> {
    return arr.reduce((agg, cur) => {
        const key = keyFunc(cur);
        const arr = agg.get(key) ?? [];
        agg.set(key, [...arr, cur]);
        return agg;
    }, new Map<TKey, TEntity[]>());
}
